import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { useAuth } from '../context/AuthContext';

// Component to handle protected routes
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();

    // If not authenticated, redirect to login
    if (!isAuthenticated) return <Navigate to={ROUTES.login} replace />;

    // Otherwise, render the children components
    return children;
};

export default ProtectedRoute;
